module.exports = __webpack_public_path__ + "media/application/images/svgs/list-13a1400d6ed865f342b564b2863c5212.svg";